import React from "react";

const MAP = {
  active: { label: "Active", bg: "#DCFCE7", fg: "#15803D", border: "#15803D" },
  paid: { label: "Paid", bg: "#DCFCE7", fg: "#15803D", border: "#15803D" },
  completed: { label: "Completed", bg: "#DCFCE7", fg: "#15803D", border: "#15803D" },
  sold: { label: "Sold", bg: "#DCFCE7", fg: "#15803D", border: "#15803D" },
  resolved: { label: "Resolved", bg: "#DCFCE7", fg: "#15803D", border: "#15803D" },
  closed: { label: "Closed", bg: "#E7E5E4", fg: "#57534E", border: "#57534E" },
  pending: { label: "Pending", bg: "#FEF3C7", fg: "#92400E", border: "#92400E" },
  in_progress: { label: "In Progress", bg: "#FEF3C7", fg: "#92400E", border: "#92400E" },
  planning: { label: "Planning", bg: "#DBEAFE", fg: "#1E3A8A", border: "#1E3A8A" },
  on_hold: { label: "On Hold", bg: "#E7E5E4", fg: "#57534E", border: "#57534E" },
  booked: { label: "Booked", bg: "#DBEAFE", fg: "#1E3A8A", border: "#1E3A8A" },
  available: { label: "Available", bg: "#F5F5F4", fg: "#0C0A09", border: "#0C0A09" },
  overdue: { label: "Overdue", bg: "#FEE2E2", fg: "#991B1B", border: "#991B1B" },
  suspended: { label: "Suspended", bg: "#FEE2E2", fg: "#991B1B", border: "#991B1B" },
  cancelled: { label: "Cancelled", bg: "#E7E5E4", fg: "#57534E", border: "#57534E" },
  deactivated: { label: "Deactivated", bg: "#FEE2E2", fg: "#991B1B", border: "#991B1B" },
  open: { label: "Open", bg: "#DBEAFE", fg: "#1E3A8A", border: "#1E3A8A" },
  urgent: { label: "Urgent", bg: "#FEE2E2", fg: "#991B1B", border: "#991B1B" },
  high: { label: "High", bg: "#FEF3C7", fg: "#92400E", border: "#92400E" },
  normal: { label: "Normal", bg: "#F5F5F4", fg: "#0C0A09", border: "#0C0A09" },
  low: { label: "Low", bg: "#F5F5F4", fg: "#57534E", border: "#57534E" },
};

export default function StatusBadge({ value, label, testId }) {
  const key = String(value || "").toLowerCase();
  const style = MAP[key] || MAP.normal;
  return (
    <span
      className="status-badge"
      data-testid={testId || `status-${key}`}
      style={{
        backgroundColor: style.bg,
        color: style.fg,
        borderColor: style.border,
      }}
    >
      {label || style.label || String(value)}
    </span>
  );
}
